export default {"src":"/_next/static/media/arrow_up_active.31db0486.svg","height":5,"width":8,"blurWidth":0,"blurHeight":0};